module.exports = __webpack_public_path__ + "static/media/users.0a1415e6.svg";